import { ArrowRight, Smartphone } from "lucide-react";

import {
  buildNativeAuthReturnUrl,
  isAndroidWebBrowser,
  isNativeAuthReturnScheme,
} from "@/lib/nativeAppLinks";

export default function NativeAppReturnLink({ result, returnScheme, children = "Öppna Lapstr-appen" }) {
  if (!isAndroidWebBrowser() || !isNativeAuthReturnScheme(returnScheme)) return null;

  return (
    <a className="native-app-return-link" href={buildNativeAuthReturnUrl(result, returnScheme)}>
      <Smartphone aria-hidden="true" />
      <span>{children}</span>
      <ArrowRight aria-hidden="true" />
    </a>
  );
}
